// removed by extract-text-webpack-plugin
module.exports = {"container":"_3rOLoSTc6cW_AzccRoQBRn","build":"MjkMGBZxcjc9CC_U47-mU","active":"nkAClq4T6cTaeekBvxPA_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WhatIDo.css
// module id = 94
// module chunks = 0